module.exports = __webpack_public_path__ + "static/media/video_svg.ab238f2c.svg";